const trimFulltext = (fulltext?: string, minLength = 2) =>
  fulltext && fulltext.trim().length > minLength ? fulltext : undefined;

export default trimFulltext;
